module.exports = __webpack_public_path__ + "img/add-min.c4b56658.png";